'use client'

import Link from 'next/link'
import { useMemo } from 'react'

import { nextLinkHrefFromPathWithOptionalHash } from '@/_lib/next-link-href'
import { handleProgramaticScroll } from '@/_lib/utils'

export default function ZCategoryNavigationLink({
	href,
	category,
	className,
	categoryNameKey
}: {
	href: string
	category: {
		slug: string
		name: string
		nameShort?: string
	}
	categoryNameKey?: string
	className: string
}) {
	const categoryName = useMemo(() => {
		return categoryNameKey && category[categoryNameKey as keyof typeof category]
			? category[categoryNameKey as keyof typeof category]
			: category['name']
	}, [category, categoryNameKey])

	const categoryNameShort = useMemo(() => {
		return category.nameShort ? category.nameShort : category.name
	}, [category])

	return (
		<Link
			href={nextLinkHrefFromPathWithOptionalHash(href)}
			data-value={category.slug}
			title={categoryName}
			className={className}
			prefetch={false}
			onClick={handleProgramaticScroll}
		>
			<span className='show_lgm'>{categoryNameShort}</span>
			<span className='hide_lgm'>{categoryName}</span>
		</Link>
	)
}
